import { render, staticRenderFns } from "./EtebsList.vue?vue&type=template&id=23fabde4&"
import script from "./EtebsList.vue?vue&type=script&lang=js&"
export * from "./EtebsList.vue?vue&type=script&lang=js&"
import style0 from "./EtebsList.vue?vue&type=style&index=0&id=23fabde4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports